import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import Modal from "react-modal"

import QuestionForm from "components/forums/QuestionForm"
import AnswerForm from "components/forums/AnswerForm"
import CommentForm from "components/forums/CommentForm"

import { submitForumQuestion } from "store/school/actions"

import "styles/components/common/forum-modal.scss"
import { FORUM_MODAL_TYPES } from "constants/modal-types"

class ForumModal extends Component {
  constructor() {
    super()

    this.state = {
      fieldErrors: {},
    }
  }

  renderForm(formType) {
    switch (formType) {
      case FORUM_MODAL_TYPES.QUESTION:
        return <QuestionForm />
      case FORUM_MODAL_TYPES.ANSWER:
        return <AnswerForm />
      case FORUM_MODAL_TYPES.COMMENT:
        return <CommentForm />
      default:
        return <div style={{ minHeight: "240px" }} />
    }
  }

  renderTitle(formType) {
    switch (formType) {
      case FORUM_MODAL_TYPES.QUESTION:
        return "Ask a Question"
      case FORUM_MODAL_TYPES.ANSWER:
        return "Answer Question"
      case FORUM_MODAL_TYPES.COMMENT:
        return "Leave a Comment"
      default:
        return ""
    }
  }

  renderEditTitle(formType) {
    switch (formType) {
      case FORUM_MODAL_TYPES.QUESTION:
        return "Edit Question"
      case FORUM_MODAL_TYPES.ANSWER:
        return "Edit Answer"
      case FORUM_MODAL_TYPES.COMMENT:
        return "Edit Comment"
      default:
        return ""
    }
  }

  render() {
    const { modalType, isEdit, isOpen, closeModal } = this.props

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        className="forum-modal"
        overlayClassName="forum-modal-overlay"
      >
        <Fragment>
          <div className="forum-modal-header">
            {isEdit
              ? this.renderEditTitle(modalType)
              : this.renderTitle(modalType)}
          </div>
          <div className="forum-modal-container">
            {this.renderForm(modalType)}
          </div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      submitForumQuestion,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(ForumModal)
